import React, {useRef, useState} from 'react';
import {useFrame, useLoader} from '@react-three/fiber';
import * as THREE from 'three';

export default function ProjectStar({project, isSelected, onSelect}) {
    const spriteRef = useRef();
    const [hovered, setHovered] = useState(false);
    const thumbnail = project?.images ? project?.images[0] : project?.image;
    const texture = useLoader(THREE.TextureLoader, thumbnail);

    useFrame((state) => {
        if (!spriteRef.current) return;
        const t = state.clock.getElapsedTime();
        const baseScale = hovered || isSelected ? 3.2 : 2.6;
        const pulse = Math.sin(t * 1.5 + project.position[0]) * 0.08;
        const scale = baseScale + pulse;
        spriteRef.current.scale.set(scale, scale, 1);
    });

    return (
        <sprite
            ref={spriteRef}
            position={project.position}
            onClick={(e) => {
                e.stopPropagation();
                onSelect();
            }}
            onPointerOver={(e) => {
                e.stopPropagation();
                setHovered(true);
                document.body.style.cursor = 'pointer';
            }}
            onPointerOut={() => {
                setHovered(false);
                document.body.style.cursor = 'auto';
            }}
        >
            <spriteMaterial
                map={texture}
                transparent
                opacity={hovered || isSelected ? 1 : 0.9}
            />
        </sprite>
    );
}
